module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery3-87ca644f1b2dc3c0919631b680f3a6bf.png";